export const DEFAULT_REM_API_BASE_URL = "https://my.remapp.ae";

/** REM API base URL — from REM_API_BASE_URL / NEXT_PUBLIC_REM_API_BASE_URL */
export function getRemApiBaseUrl(): string {
  return (
    process.env.REM_API_BASE_URL ??
    process.env.NEXT_PUBLIC_REM_API_BASE_URL ??
    DEFAULT_REM_API_BASE_URL
  ).replace(/\/$/, "");
}

/** Server-only lead API token */
export function getRemApiToken(): string | undefined {
  return process.env.REM_API_TOKEN;
}

/** Upstream REM create-lead URL (server-side) */
export function getRemCreateLeadUrl(): string {
  const token = getRemApiToken();
  if (!token) {
    throw new Error("REM_API_TOKEN is not configured");
  }
  return `${getRemApiBaseUrl()}/api/create-lead/${token}`;
}

/**
 * Lead form POST URL for browser forms.
 * SECURITY: Always use the local Next.js proxy route to avoid exposing
 * the REM API token in client-side JavaScript bundles.
 */
export function getSubmitLeadApiUrl(): string {
  return "/api/submit-lead";
}

export const SUBMIT_LEAD_API_URL = getSubmitLeadApiUrl();
